<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(execAction)">
        <div class="col-md-12 ml-auto mr-auto">
          <card class="card-login card-plain">
            <div slot="header">
              <div class="logo-container" style="margin-bottom: 20px;">
                <img src="img/logo2.png" alt="" style="width: 90px;"/>
              </div>
            </div>

            <div>

              <!--
              <label style="font-size: 13px; margin-bottom: 30px; text-align: justify; color: black"
              >{{ $t('app.modules.login.headers.text_request') }}
                <strong>{{ $t('app.modules.login.headers.request') }}</strong>.</label
              >
              -->

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ passed, failed }"
              >
                <fg-input
                  type="email"
                  :error="failed ? $t('app.general.required') : null"
                  :hasSuccess="passed"
                  class="no-border form-control-lg txt_login input"
                  :placeholder="$t('app.modules.login.headers.email')"
                  addon-left-icon="now-ui-icons ui-1_email-85"
                  v-model="email"
                >
                </fg-input>
              </ValidationProvider>

              <div v-if="!forgetPass">
                <ValidationProvider
                                    name="password"
                                    rules="required|min:5"
                                    v-slot="{ passed, failed }"
                >
                  <fg-input
                    type="password"
                    :error="failed ? $t('app.general.required') : null"
                    :hasSuccess="passed"
                    class="no-border form-control-lg txt_login input"
                    :placeholder="$t('app.modules.login.headers.password')"
                    addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                    v-model="password"
                  >
                  </fg-input>
                </ValidationProvider>
                <a href="#" @click.prevent="forgetPass = true;" style="font-size: 13px; color: white;">{{ $t('app.modules.login.buttons.forgot_pass') }}</a>
              </div>
              <a v-else href="#" @click.prevent="forgetPass = false;" style="font-size: 13px; color: white;">{{ $t('app.modules.login.buttons.return') }}</a>


            </div>
            <div slot="footer">
              <div class="row">
                <div class="col-12">
                  <n-button v-if="!forgetPass" type="primary" native-type="submit" round block text-uppercase style="width: 100% !important; ">
                    {{ $t('app.modules.login.buttons.log_on') }}
                  </n-button>
                  <n-button v-else type="primary" native-type="submit" round block text-uppercase style="width: 100% !important; ">
                    {{ $t('app.modules.login.buttons.recover_pass') }}
                  </n-button>
                </div>
              </div>
            </div>
          </card>
        </div>
      </form>
    </ValidationObserver>
  </div>

</template>
<script>

import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
import { mapState, mapMutations } from "vuex";
import Swal from "sweetalert2";
import { getResponse } from "@/util/utilities";

extend("email", email);
extend("required", required);
extend("min", min);

export default {
  name: "login",
  computed: {
  },
  data() {
    return {
      email: "",
      password: "",
      credentials: { Alias: "", Contrasena: "" },
      forgetPass: false
    };
  },
  created(){

  },
  methods: {
    ...mapMutations({
      setLoggedIn: "SET_LOGGED_IN",
      setLang: "SET_LANG",
      setUser: "SET_USER",
      setToken: "SET_TOKEN",
      //setRoles: "SET_ROLES",
      setRols: "SET_ROLS",
      //setModules: "SET_MODULES",
      setAvailableLangs: "SET_AVAILABLE_LANGS",
      setLoginDate: "SET_LOGIN_DATE",
      setRecentlyLoggedIn: 'SET_IS_RECENTLY_LOGGED_IN'
    }),
    changeLanguage(value) {
      this.setLang(value);
      this.$root.$i18n.locale = value;
    },
    execAction(){
      Swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });

      if(!this.forgetPass){
        this.login();
      }
      else {
        this.recoverPass();
      }

      Swal.close();
    },
    async login(){
      this.credentials.Alias = this.email;
      this.credentials.Contrasena = this.password;
      this.credentials.OnlyExternal = true;

      let request = await this.$http.post(route("Usuarios/validateUserAdmin"), this.credentials);
      let response = getResponse(request);

      if(response != null){
        await this.initUser(response.usuarios[0]);
        EventBus.$emit("delete-messages");
      }
      else this.notifyMessage("danger", this.$t("app.modules.login.errors.invalid_user"));
    },
    async initUser(user){
      this.credentials.Alias = "";
      this.credentials.Contrasena = "";
      this.setUser(user);
      this.setToken(user.token);
      //this.setRoles(user.roles);
      this.setRols(user.rols);
      //this.setModules(user.modulosRoles);
      this.setLoggedIn(true);
      this.setLoginDate(new Date().toJSON().slice(0,10).replace(/-/g,'/'));
      this.setRecentlyLoggedIn(true)

      await this.$http
        .get(route("Idiomas/getIdiomas"))
        .then(
          async _response => {
            if (_response.body.code === 200) {
              this.setAvailableLangs(_response.body.idiomas);
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
        if(this.$route.query.redirect){
          //console.log(this.$route.query.redirect);
            this.$router.push(this.$route.query.redirect);
        }else{
          this.$router.push({
            name: "Añadir por Numero de Parte"
          });
        }
    },
    async recoverPass(){

      let request = await this.$http.post(route("Usuarios/passwordChangeRequest"), {"email": this.email});
      let response = getResponse(request);

      if(response != null){
        this.notifyMessage("success", this.$t("app.modules.login.success.request_sent"));
      }
      else this.notifyMessage("danger", this.$t("app.modules.login.errors.request_failed"));
    }
  },
  mounted() {
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
.section-image:after {
  background-color: rgba(0, 0, 0, 0) !important;
}
.full-page:after {
  background-color: rgba(0, 0, 0, 0) !important;
}
hr {
  border-top: 1px solid rgba(0, 0, 0, 0) !important;
}

.input {

}
.input .input-group-addon {
  background-color: #726f6b !important;
}
.input .input-group-addon > i {
  color: white;
}
.login-page .card-login .input-group:last-child {
  margin-bottom: 20px;
}

.input .form-control {
  background-color: #726f6b !important;
}

/*button {
  text-transform: uppercase;
}*/
</style>
